import axios from 'axios';
import toastr from 'toastr';

export default {
    name: 'AddQualification',
    props: {

    },

    computed: {

    },
    data() {
        return {
            initialized: false,
            educationqualifications: [],
            selectedQualifications: [],
            attendant: null,

        };
    },
    watch: {
        attendant() {
            this.getAttendantQualifications();
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            let educationQualificationsUrl = APIURL + '/educationqualification/all/';
            axios.get(educationQualificationsUrl)
                .then(resp => {
                    this.educationqualifications = resp.data;
                });
        },
        save() {
            if (this.selectedQualifications.length > 0) {
                let savedata = this.selectedQualifications.map(id => ({ id}));
                console.log(savedata);
                axios.put(APIURL + '/educationqualification/attendantmap/' + this.attendant, savedata)
                    .then(() => {
                        toastr.success(this.$t('success.saveChanges'), '');
                        this.$vuedals.close();
                    })
                    .catch(err => {
                        toastr.error(this.$t('error.saveChanges'), err);
                    });
            }
        },
        getAttendantQualifications() {
            if (this.attendant > 0) {
                axios.get(APIURL + '/educationqualification/attendant/' + this.attendant)
                    .then(resp => {
                        this.selectedQualifications = resp.data.map(x => x.id);
                    })
                    .catch(err => {
                        toastr.error(this.$t('error.saveChanges'), err);
                    });;
            }
        },
        dismiss() {
            this.$vuedals.dismiss();
        },
        setAttendant(val) {
            this.attendant = val;
        }
    }
};